import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

import { tokens, Text } from '@hotjar/hotsauce';
import { useTrafficCoverage } from '@hotjar/webapp/hooks/useTrafficCoverage';
import { useTargetingSettings } from '@hotjar/webapp/hooks/useTargetingSettings';
import { useCurrentSite } from '@hotjar/site';

const List = styled.ul`
  padding-left: ${tokens.spacer.x3};
`;

export const TrackingSettingsDetails = (): JSX.Element => {
  const { t } = useTranslation();
  const { data: currentSite } = useCurrentSite();
  const {
    isLoading: trafficCoverageLoading,
    isCoverageMeasureComplete,
    coveragePercentage,
  } = useTrafficCoverage();
  const {
    isLoading: targetingLoading,
    sessionIncludeShort,
    targetingRulesPresent,
    targetingRulesWithJsTriggerPresent,
    targetingRulesWithPageRulePresent,
  } = useTargetingSettings(currentSite);

  return (
    <List>
      {isCoverageMeasureComplete && !trafficCoverageLoading ? (
        <Text textType="body2" as="li" textColor="text_light">
          {t('activation:dashboard.status-card.coverage', { coveragePercentage })}
        </Text>
      ) : null}
      {!targetingLoading ? (
        <>
          {!sessionIncludeShort && (
            <Text textType="body2" as="li" textColor="text_light">
              {t(
                'common:sampling-widget.tracking-coverage-message.settings.30-second-duration-disabled',
              )}
            </Text>
          )}
          {!targetingRulesPresent && (
            <Text textType="body2" as="li" textColor="text_light">
              {t('common:sampling-widget.tracking-coverage-message.settings.no-targeting-rule')}
            </Text>
          )}
          {targetingRulesWithPageRulePresent && !targetingRulesWithJsTriggerPresent && (
            <Text textType="body2" as="li" textColor="text_light">
              {t(
                'common:sampling-widget.tracking-coverage-message.settings.targeting-rule-with-only-page-rule',
              )}
            </Text>
          )}
          {!targetingRulesWithPageRulePresent && targetingRulesWithJsTriggerPresent && (
            <Text textType="body2" as="li" textColor="text_light">
              {t(
                'common:sampling-widget.tracking-coverage-message.settings.targeting-rule-with-only-js-trigger',
              )}
            </Text>
          )}
          {targetingRulesWithPageRulePresent && targetingRulesWithJsTriggerPresent && (
            <Text textType="body2" as="li" textColor="text_light">
              {t(
                'common:sampling-widget.tracking-coverage-message.settings.targeting-rule-with-js-trigger-and-page-rule',
              )}
            </Text>
          )}
        </>
      ) : null}
    </List>
  );
};
